import BaseStore from '@/store/baseStore'
import BaseRevisionStore from '@/store/baseRevisionStore'

export const namespaced = true

const baseURI = '/water_line_rule_revisions/'

const baseStore = new BaseStore(baseURI)
const baseRevisionStore = new BaseRevisionStore(baseURI)

const getDefaultState = () => {
  return {
    ...structuredClone(baseStore.state),
    ...structuredClone(baseRevisionStore.state),
    fields: ['name']
  }
}

export const state = getDefaultState()

export const mutations = {
  ...baseStore.mutations,
  ...baseRevisionStore.mutations,
  RESET_STATE(state) {
    Object.assign(state, getDefaultState())
  }
}
export const actions = {
  ...baseStore.actions,
  ...baseRevisionStore.actions,
  resetState({ commit }) {
    commit('RESET_STATE')
  }
}

export const getters = {
  ...baseRevisionStore.getters
}
